import React, { useEffect, useState } from "react";
import { Text, Box } from "@mantine/core";
import { TimerIcon } from "../../icons/timer";

type HostTimerProps = {
  seconds: number;
  isVisible: boolean;
  onTimerEnd: () => void;
};

const HostTimer = ({ seconds, isVisible, onTimerEnd }: HostTimerProps) => {
  const [remainingSeconds, setRemainingSeconds] = useState(seconds);
  const [futureTime, setFutureTime] = useState(Date.now() + seconds * 1000);
  const [colVal, setColVal] = useState(0);
  const removeSecond = () => {
    const now = Date.now();
    const diff = Math.floor((futureTime - now) / 1000);
    setRemainingSeconds(diff);
  };
  useEffect(() => {
    if (remainingSeconds >= 0) {
      setTimeout(removeSecond, 1000);
      setColVal(remainingSeconds > 30 ? 255 : (255 * remainingSeconds) / 30);
    } else {
      onTimerEnd();
      setRemainingSeconds(-1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remainingSeconds]);
  useEffect(() => {
    if (seconds > 0) {
      setRemainingSeconds(seconds);
      setFutureTime(Date.now() + seconds * 1000);
      setTimeout(removeSecond, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seconds]);
  const formatTime = (val: number) => {
    if (val < 10) {
      return "0" + val;
    }
    return "" + val;
  };
  return (
    <Box
      style={{
        position: "absolute",
        height: "calc(10vh)",
        width: "calc(10vh)",
        right: 30,
        top: 15,
        color: "rgb(255," + colVal + "," + colVal + ")",
      }}
    >
      {remainingSeconds >= 0 && isVisible && (
        <>
          <Text
            style={{
              position: "absolute",
              fontSize: "calc(2vh)",
              top: "calc(2vh)",
              right: "calc(2vh)",
            }}
          >
            {formatTime(Math.floor(remainingSeconds / 60)) +
              " : " +
              formatTime(remainingSeconds % 60)}
          </Text>
          <TimerIcon />
        </>
      )}
    </Box>
  );
};

export default HostTimer;
